import { CalendlyAppointment } from "../api-objects/CalendlyAppointment";
import { BASE_URL, requestOptionsGET } from "../Constants";
import { ConsultType, ExpertRole } from "../Enums";
import { ErrorWithMessageCallback, GetAppointmentsSuccessCallback, handleApiResponse } from "./callback-helpers";

export async function getAppointmentsByOrganizerEmail(
    idToken: string,
    email: string,
    role?: ExpertRole,
    handleSessionExpiry?: () => void,
): Promise<CalendlyAppointment[] | null> {
    try {
        let realEmail = email;
        if (email === "vittoria.ferla@holifya.com") {
            realEmail = "dr.gentilesalvatore@gmail.com";
        }
        const endpoint = role === ExpertRole.Admin ? `${BASE_URL}/api/booking/appointments-list` : `${BASE_URL}/api/booking/appointments/organizer/${realEmail}`
        const response = await fetch(
            `${endpoint}`,
            requestOptionsGET(idToken)
        );
        if (!response.ok) {
            if (response.status === 401 && handleSessionExpiry) {
                handleSessionExpiry(); // Handle session expiry if needed
            }
            if (response.status === 404) {
                const message = role === ExpertRole.Admin ? "No appointments found." : `No appointments found for organizer with email ${email}.`
                // Handle 404 if no appointments are found
                console.warn(message);
                return []; // Returning an empty array instead of null
            }

            const errorMessage = await response.text();
            throw new Error(`Failed to fetch appointments: ${response.statusText}. ${errorMessage}`);
        }
        return await response.json()
    } catch (error) {
        console.error("Get appointments failed:", error);
        return null;
    }
}

export async function getAppointmentsByUserEmail(
    idToken: string,
    email: string,
    onSuccess: GetAppointmentsSuccessCallback,
    onError: ErrorWithMessageCallback,
    handleSessionExpiry?: () => void
) {
    try {
        const response = await fetch(
            `${BASE_URL}/api/booking/appointments/${email}`,
            requestOptionsGET(idToken)
        );
        await handleApiResponse<CalendlyAppointment[]>(response, onSuccess, onError, handleSessionExpiry);
    } catch (error) {
        console.error("Get appointments failed:", error);
        onError("An unexpected error occurred");
    }
}

export async function readsConsultsLeft(
    user_id: string,
    id_token: string,
    consult_type: ConsultType,
    // purchase_type?: PurchaseType,
): Promise<number> {
    // const realType = purchase_type !== undefined ? purchase_type : PurchaseType.OneOff
    const endpoint =
    // purchase_type !== undefined
        // ? `${BASE_URL}/api/consults/consult_type/${consult_type}/user_id/${user_id}/purchase_type/${realType}`
        // :
        `${BASE_URL}/api/consults/consult_type/${consult_type}/user_id/${user_id}`

    try {
        const response = await fetch(endpoint, requestOptionsGET(id_token))
        if (response.ok) {
            const consultsLeft: number = await response.json()
            return consultsLeft;
        } else if (response.status === 401) {
            throw new Error("Session expired");
        } else {
            throw new Error("Errore");
        }
    } catch (error) {
        console.error("Get consults left failed:", error);
        throw error;
    }
}

export async function reducesConsultsLeft(
    user_id: string,
    id_token: string,
    consult_type: ConsultType,
    onSuccess: (left: number) => void,
    onError: ErrorWithMessageCallback,
) {
    try {
        const response = await fetch(`${BASE_URL}/api/consults/reduce/${user_id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': id_token,
            },
            body: JSON.stringify(
                {
                    consult_type,
                }
            ),
        })
        if (response.ok) {
            const consultsLeft: number = await response.json()
            onSuccess(consultsLeft)
        } else {
            onError("Errore")
        }
    } catch (error) {
        console.error("Reduce consults left failed:", error);
        return { success: false, error: "An unexpected error occurred" };
    }
}

export async function increaseConsultsLeft(
    user_id: string,
    id_token: string,
    consult_type: ConsultType,
    onSuccess: (left: number) => void,
    onError: ErrorWithMessageCallback,
) {
    try {
        const response = await fetch(`${BASE_URL}/api/consults/increase/${user_id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': id_token,
            },
            body: JSON.stringify(
                {
                    consult_type,
                }
            ),
        })
        if (response.ok) {
            const consultsLeft: number = await response.json()
            onSuccess(consultsLeft)
        } else {
            onError("Errore")
        }
    } catch (error) {
        console.error("Increase consults left failed:", error);
        return { success: false, error: "An unexpected error occurred" };
    }
}
